import { render } from "./BpfFilterBuilder.vue?vue&type=template&id=05196d8e"
import script from "./BpfFilterBuilder.vue?vue&type=script&lang=js"
export * from "./BpfFilterBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__